import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import StatusBadge from '../Common/StatusBadge';
import { statusConfig } from '../../config/statusConfig';

const ViewConnectionModal = ({ show, onHide, connection }) => {
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "₹0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  if (!connection) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Connection Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <small className="text-muted d-block">Connection Number</small>
              <strong>{connection.connection_number}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Gas Type</small>
              <strong>{connection.gas_type?.toUpperCase() || "LPG"}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Cylinder Capacity</small>
              <strong>{connection.cylinder_capacity}</strong>
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Connection Date</small>
              <strong>{formatDate(connection.connection_date)}</strong>
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-3">
              <small className="text-muted d-block">Status</small>
              <StatusBadge status={connection.connection_status} config={statusConfig} />
            </div>
            <div className="mb-3">
              <small className="text-muted d-block">Security Deposit</small>
              <strong>{formatCurrency(connection.security_deposit || 0)}</strong>
            </div>
            {connection.regulator_number && (
              <div className="mb-3">
                <small className="text-muted d-block">Regulator Number</small>
                <strong>{connection.regulator_number}</strong>
              </div>
            )}
            {connection.stove_details && (
              <div className="mb-3">
                <small className="text-muted d-block">Stove Details</small>
                <p className="mb-0">{connection.stove_details}</p>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewConnectionModal;